import module from 'contabilidad/polizas/module.js'
import template from './template.html'
import { groupBy } from 'lodash'

export class ContabilidadPolizasProvisioningresospagosListaComponent {
  constructor ($filter) {
    this.filterBy = $filter('filter')
  }

  data
  clientes = {}
  filtro = ''

  $onChanges (changes) {
    if (changes.data) {
      this.filtrar()
    }
  }

  filtrar () {
    this.clientes = groupBy(this.filterBy(this.data, this.filtro), 'Nombre_Cliente')
  }
}

module.component('contabilidadPolizasProvisioningresospagosLista', {
  controller: ContabilidadPolizasProvisioningresospagosListaComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/provisioningresospagos/lista/component.js